import { Rank } from '@components'
import { Card, Text } from '@here/components'
import { useNavigate } from '@solidjs/router'
import dayJs from 'dayjs'
import { type Component, Show, createSignal } from 'solid-js'
import { useService } from 'solid-services'
import { css } from 'styled-system/css'
import { Box, Flex, Grid } from 'styled-system/jsx'
import { useChannel, useUi } from '../../state'
import type { DisplayMessage } from '../../state/resources/getChannelHistory'
import Actions from './Actions'
import { Avatar } from './Avatar'
import Reactions from './Reactions'
import RichText from './RichText'

const format = 'DD/MM HH:mm'

export const Item: Component<{
	message: DisplayMessage
	isMine?: boolean
	showMessageAuthor?: boolean
	isFocus?: boolean,
  isMinimal?: boolean
}> = (props) => {
	const navigate = useNavigate()
	const { setScrollTo, messages } = useService(useChannel)()
	const { channelPathRoot } = useService(useUi)()
	const [isHovering, setisHovering] = createSignal()
	const lastUpdated = (props.message.profile as any)?.last_seen?.updated_at
	const created = props.message.created_at
	const borderColor = props?.isMine ? 'tscGreen.3' : 'tscGreen.9'

	const time = () => dayJs(new Date(created)).format(format)

	const navigateToReply = () => {
		const isInChat = Boolean(
			messages.some((message) => message.id === props.message.parent_id),
		)
		if (!isInChat) {
			navigate(`${channelPathRoot()}/message/${props.message.parent_id}`)
		} else {
			if (props.message.parent_id) {
				setScrollTo({
					id: props.message.parent_id,
					behavior: 'smooth',
					align: 'center',
					isHighlight: true,
				})
			}
		}
	}

	return (
		<Flex
			id={props.message.id}
			gap={1}
			// gridTemplateColumns={props?.isMine ? '1fr' : '50px 1fr'}
			justifyContent={props?.isMine ? 'end' : 'start'}
			mt={props?.showMessageAuthor ? 2 : 1}
			position="relative"
			onMouseEnter={() => setisHovering(true)}
			onMouseLeave={() => setisHovering(false)}
		>
			<Box>
				<Show when={!props.isMine && !props.isMinimal}>
					<Avatar
						id={props.message.created_by}
						hide={!props.showMessageAuthor}
						lastSeen={lastUpdated}
					/>
				</Show>
			</Box>
			<Grid
				gap={1}
				justifyItems={props.isMine ? 'end' : 'start'}
			>
				<Show when={!props.isMine && props.showMessageAuthor}>
					<Flex
						alignItems="center"
						gap={1}
					>
						<Text
							variant="heading"
							fontWeight="bold"
							size="xs"
							children={(props.message?.profile as any)?.username}
						/>
						<Rank rank={(props.message?.profile_private as any).role} />
					</Flex>
					{/* <Rank rank={props.message?.profile as any)?.rank} /> // TODO add rank */}
				</Show>
				<Show when={props.message.parent_preview_text}>
					<Card.Root
						cursor="pointer"
						onClick={navigateToReply}
						mt={'-10px'}
						transform={
							props.isMine
								? ' translateY(10px) translateX(-4px)'
								: 'translateY(10px) translateX(4px)'
						}
						background="bg.emphasized"
						transition="background 0.3 ease"
						p={2}
						_hover={{
							background: 'bg.muted',
						}}
					>
						<Text size="xs">{props.message.parent_preview_text}</Text>
					</Card.Root>
				</Show>
				<Flex
					class={css({
						width: 'auto',
						alignItems: 'center',
						flexDirection: props?.isMine ? 'row-reverse' : 'row',
						gap: 1,
					})}
				>
					<Card.Root
						class={css({
							p: 2,
							gap: 2,
              minH: '65px',
              justifyContent: 'space-between',
							textAlign: props?.isMine ? 'right' : 'left',
							background: 'bg.subtle',
							border: props.isFocus
								? 'solid 1px var(--colors-tsc-green-emphasized)'
								: '',
						})}
					>
						<RichText content={props.message.content} />
            <Text fontSize="8px">{time()}</Text>
					</Card.Root>
					<Grid
						alignSelf="start"
						gap={0}
						opacity={0.1}
						transition="opacity 0.3s ease"
						_hover={{
							opacity: 1,
						}}
					>
						<Actions
              isMinimal={props?.isMinimal}
							isMine={props.isMine}
							channelPathRoot={channelPathRoot()}
							message={props.message}
						/>
					</Grid>
				</Flex>
					<Reactions
						messageId={props.message.id}
						reactions={props.message.message_reaction}
					/>
			</Grid>
		</Flex>
	)
}

export default Item
